import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import RichTextEditor from 'react-rte';
import Api from '../../../../services/Api';
import BasePage from '../../BasePage/BasePage';
import ImageCarousel from '../../../atoms/ImageCarousel/ImageCarousel';
import Grid from '../../../atoms/Grid/Grid';
import InputControl from '../../../atoms/InputControl/InputControl';
import TagsInput from '../../../atoms/TagsInput/TagsInput';
import DynastySelector from '../../../atoms/DynastySelector/DynastySelector';
import CitySelector from '../../../atoms/CitySelector/CItySelector';
import CitationEditor from '../../../molecules/CitationEditor/CitationEditor';
import Button from '../../../atoms/Button/Button';
import Icon from '../../../atoms/Icon/Icon';
import {
  addContextSuccessAction,
  getContextSuccessAction,
} from '../../../../actions/instances/context';
import { loadBuildingsMetadata } from '../../../../helpers/metadata';
import extractErrors from '../../../../helpers/errors';
import BuildingTypeSelector from '../../../atoms/BuildingTypeSelector/BuildingTypeSelector';
import InstanceDocumentEditor from '../../../Organisms/InstanceDocumentEditor/InstanceDocumentEditor';
import { fetchBuildingsInitAction, setSelectedBuildingAction } from '../../../../actions/instances/buildings';
import './CreateEditBuilding.scss';

const CreateEditBuilding = () => {
  const building = useSelector(state => state.buildings.selectedBuilding);
  let mainImage;
  let restOfImages = [];
  if (building) {
    if (building.images !== undefined || building.images !== null) {
      if (building.images.length > 0) {
        [mainImage] = building.images;
        restOfImages = building.images.slice(0, 1);
      }
    }
  }
  const [imagesIds, setImagesIds] = useState(restOfImages);
  const [mainImageId, setMainImageId] = useState(mainImage);
  const [name, setName] = useState(building ? building.name : undefined);
  const [number, setNumber] = useState(building ? building.number : undefined);
  const [description, setDescription] = useState(
    building ? RichTextEditor.createValueFromString(
      building.description || '',
      'html',
    ) : RichTextEditor.createEmptyValue(),
  );
  const [startDate, setStartDate] = useState(building ? building.start_date : undefined);
  const [endDate, setEndDate] = useState(building ? building.end_date : undefined);
  const [founder, setFounder] = useState(building ? building.founder : undefined);
  const [architect, setArchitect] = useState(building ? building.architect : undefined);
  const [location, setLocation] = useState(building ? building.location : undefined);
  const [buildingTypeId, setBuildingTypeId] = useState(
    building ? building.building_type_id : undefined,
  );
  const [dynastyId, setDynastyId] = useState(building ? building.dynasty_id : undefined);
  const [cityId, setCityId] = useState(building ? building.city.id : undefined);
  const [countryId, setCountryId] = useState(building ? building.city.country.id : undefined);
  const [documentsIds, setDocumentsIds] = useState(
    building ? building.documents.map(doc => doc.id) : [],
  );
  const [resourcesIds, setResourcesIds] = useState(
    building && building.citation ? building.citation.map(c => c.id) : undefined,
  );
  const [errors, setErrors] = useState(undefined);
  const [tagsIds, setTagsIds] = useState(
    building && building.tags ? building.tags.map(t => t.id) : undefined,
  );
  const [isLoading, setIsLoading] = useState(false);
  const [citationObjects, setCitationObjects] = useState([]);
  useEffect(() => {
    if (building) {
      loadBuildingsMetadata(building.id).then(response => setCitationObjects(response.citation));
    }
  }, []);
  const [updatedTag, setUpdatedTag] = useState('');
  // Function to receive new tag created in the child
  const handleUpdatedTag = (data) => {
    setUpdatedTag(data);
  };
  const dispatch = useDispatch();
  const history = useHistory();
  const handleSave = () => {
    if (!name) {
      setErrors('Building name is required');
      return;
    }
    if (!buildingTypeId) {
      setErrors('You must select a type for the building');
      return;
    }
    if (!cityId) {
      setErrors('You must select a region for the building');
      return;
    }
    if (!dynastyId) {
      setErrors('You must select a dynasty for the building');
      return;
    }
    setIsLoading(true);
    const data = {
      name,
      number,
      founder: founder && founder.length > 0 ? founder : ' ',
      architect: architect && architect.length > 0 ? architect : ' ',
      location: location && location.length > 0 ? location : ' ',
      description: description.toString('html'),
      city_id: cityId,
      country_id: countryId,
      dynasty_id: dynastyId,
      images_ids: [mainImageId, ...imagesIds].filter(img => img !== undefined),
      building_type_id: buildingTypeId,
      tags_ids: tagsIds,
      resources_ids: resourcesIds,
      start_date: startDate,
      end_date: endDate,
      in_review: 1,
      documents_ids: documentsIds,
    };
    const callback = (response) => {
      setIsLoading(false);
      if (response.status === 200) {
        if (!building) {
          dispatch(addContextSuccessAction(response.data));
        } else {
          dispatch(setSelectedBuildingAction(response.data));
          dispatch(fetchBuildingsInitAction());
        }
        history.goBack();
      } else {
        const errs = extractErrors(response.data);
        setErrors([errs[0]]);
        dispatch(fetchBuildingsInitAction());
      }
    };
    if (building) {
      if (updatedTag && !tagsIds.includes(updatedTag.id)) {
        data.tags_ids = [
          ...tagsIds.filter(tag => tag != null && !Number.isNaN(tag)),
          updatedTag.id];
      } else {
        setErrors(['Please wait until the new tag is created']);
        dispatch(fetchBuildingsInitAction());
      }
      Api.patch(`instances/buildings/${building.id}`, data).then(response => callback(response));
    } else {
      Api.post('instances/buildings', data).then(response => callback(response));
    }
  };
  return (
    <BasePage>
      <div className="create-component-container">
        <h2 className="col-md-12">
          {building ? `Edit ${building.name}` : 'Create new building'}
        </h2>
        <br />
        <Grid>
          <div className="col-md-3 left-column">
            <ImageCarousel
              initialImages={building ? building.images : []}
              additionalImagesAddedCallback={images => setImagesIds(images)}
              mainImageAddedCallback={imageId => setMainImageId(imageId)}
            />
            <hr />
            <div className="col-md-12 dynasty-section">
              <InstanceDocumentEditor
                initialDocuments={building ? building.documents : []}
                onFilesChanged={(files) => {
                  setDocumentsIds(files.map(f => f.id));
                }}
              />
            </div>
            <div className="tags-container">
              <label className="tag-label">Building Tags test</label>
              <TagsInput tags={tagsIds} placeholder="Start typing..." handleUpdatedTag={handleUpdatedTag} onChange={tags => setTagsIds(tags)} />
            </div>
          </div>
          <div className="col-md-9 content-column">
            <Grid>
              <div className="col-md-12 dynasty-section">
                <label>Building Type</label>
                <BuildingTypeSelector
                  selectedId={buildingTypeId}
                  onChanged={(type) => {
                    setBuildingTypeId(type.value);
                  }}
                />
              </div>
              <div className="col-md-12 dynasty-section">
                <label>Location</label>
                <CitySelector
                  selectedId={cityId}
                  onChanged={(city) => {
                    setCityId(city.value);
                    setCountryId(city.country_id);
                  }}
                />
              </div>
              <div className="col-md-12 dynasty-section">
                <label>Building Dynasty</label>
                <DynastySelector
                  selectedId={dynastyId}
                  onChanged={(dynasty) => {
                    setDynastyId(dynasty.value);
                  }}
                />
              </div>
              <div className="col-md-12">
                <InputControl label="Building name" value={name} type="text" onValueChanged={value => setName(value)} placeholder="Name..." />
              </div>
              <div className="col-md-12">
                <InputControl label="Building Number" value={number} type="number" onValueChanged={value => setNumber(value)} placeholder="Number..." />
              </div>
              <div className="col-md-12">
                <InputControl label="Start Date" value={startDate} type="number" onValueChanged={value => setStartDate(value)} placeholder="Start Date..." />
              </div>
              <div className="col-md-12">
                <InputControl label="End Date" value={endDate} type="number" onValueChanged={value => setEndDate(value)} placeholder="End Date..." />
              </div>
              <div className="col-md-12">
                <InputControl label="Founder" value={founder} type="text" onValueChanged={value => setFounder(value)} placeholder="Founder..." />
              </div>
              <div className="col-md-12">
                <InputControl label="Architect" value={architect} type="text" onValueChanged={value => setArchitect(value)} placeholder="Architect..." />
              </div>
              <div className="col-md-12">
                <InputControl label="Location" value={location} type="text" onValueChanged={value => setLocation(value)} placeholder="Location..." />
              </div>
              <div className="col-md-12">
                <label>Building Description</label>
                <RichTextEditor
                  value={description}
                  onChange={value => setDescription(value)}
                  className="description-editor"
                />
              </div>
              <div className="col-md-12 dynasty-section">
                <CitationEditor
                  onChange={resources => setResourcesIds(resources)}
                  initialCitations={citationObjects}
                />
              </div>
              {errors && (
                <div className="col-md-12 errors-container">
                  <span className="error">{errors}</span>
                </div>
              )}
              <div className="col-md-12 actions">
                <Button
                  onInvoked={() => {
                    dispatch(getContextSuccessAction(undefined));
                    history.goBack();
                  }}
                >
                  <Icon icon="times" />
                  <span>Cancel</span>
                </Button>
                <Button onInvoked={handleSave} isLoading={isLoading}>
                  <Icon icon="save" />
                  <span>Save</span>
                </Button>
              </div>
            </Grid>
          </div>
        </Grid>
      </div>
    </BasePage>
  );
};

export default CreateEditBuilding;
